// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.test-detail-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem 1rem;
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}

.psd-toolbar {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0.45rem;
}

.psd-import-link {
  cursor: pointer;
  font-weight: bold;
  color: darkblue;
  text-decoration: underline;
}

.psd-file-input {
  display: none;
}

.psd-import-message,
.psd-import-error {
  font-size: 0.78rem;
  margin-bottom: 0.45rem;
}

.psd-import-message {
  color: #14532d;
}

.psd-import-error {
  color: #9f1239;
}

.psd-grid-four-column {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.85rem;
  align-items: start;
}

.psd-column {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.psd-grid-head {
  font-size: 0.8rem;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding-bottom: 0.2rem;
  border-bottom: 1px solid #d9e2ec;
  min-height: 1.55rem;
}

.psd-column .form-control {
  height: 1.85rem;
  font-size: 0.78rem;
  text-align: right;
}

@media (max-width: 991.98px) {
  .psd-grid-four-column {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 575.98px) {
  .psd-grid-four-column {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-psd-detail.component.scss"],"names":[],"mappings":"AAAA;EAAuB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AAKxF;;AAJA;EAAqB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,yBAAA;EAA2B,sBAAA;AAa3H;;AAZA;EAAsB,aAAA;EAAe,2DAAA;EAA6D,iBAAA;AAkBlG;;AAjBA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,WAAA;AAuB5D;;AAtBA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,WAAA;EAAa,gBAAA;AA6BjE;;AA3BA;EACC,aAAA;EACA,2BAAA;EACA,sBAAA;AA8BD;;AA3BA;EACC,eAAA;EACA,iBAAA;EACA,eAAA;EACA,0BAAA;AA8BD;;AA3BA;EACC,aAAA;AA8BD;;AA3BA;;EAEC,kBAAA;EACA,sBAAA;AA8BD;;AA3BA;EACC,cAAA;AA8BD;;AA3BA;EACC,cAAA;AA8BD;;AA3BA;EACC,aAAA;EACA,gDAAA;EACA,YAAA;EACA,kBAAA;AA8BD;;AA3BA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AA8BD;;AA3BA;EACC,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;AA8BD;;AA3BA;EACC,eAAA;EACA,kBAAA;EACA,iBAAA;AA8BD;;AA3BA;EACC;IACC,gDAAA;EA8BA;AACF;AA3BA;EACC;IACC,0BAAA;EA6BA;AACF","sourcesContent":[".test-detail-section { border: 1px solid #e3e8ef; border-radius: 4px; padding: 0.65rem; background: #ffffff; }\n.test-detail-title { margin: 0 0 0.55rem; font-size: 0.85rem; font-weight: 700; color: #3f4954; text-transform: uppercase; letter-spacing: 0.02em; }\n.test-detail-fields { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 0.65rem 1rem; }\n.test-detail-field { display: flex; flex-direction: column; gap: 0.3rem; }\n.test-detail-label { margin: 0; font-size: 0.85rem; color: #555; font-weight: 600; }\n\n.psd-toolbar {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tmargin-bottom: 0.45rem;\n}\n\n.psd-import-link {\n\tcursor: pointer;\n\tfont-weight: bold;\n\tcolor: darkblue;\n\ttext-decoration: underline;\n}\n\n.psd-file-input {\n\tdisplay: none;\n}\n\n.psd-import-message,\n.psd-import-error {\n\tfont-size: 0.78rem;\n\tmargin-bottom: 0.45rem;\n}\n\n.psd-import-message {\n\tcolor: #14532d;\n}\n\n.psd-import-error {\n\tcolor: #9f1239;\n}\n\n.psd-grid-four-column {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(4, minmax(0, 1fr));\n\tgap: 0.85rem;\n\talign-items: start;\n}\n\n.psd-column {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.4rem;\n}\n\n.psd-grid-head {\n\tfont-size: 0.8rem;\n\tfont-weight: 700;\n\tcolor: #334155;\n\ttext-transform: uppercase;\n\tletter-spacing: 0.02em;\n\tpadding-bottom: 0.2rem;\n\tborder-bottom: 1px solid #d9e2ec;\n\tmin-height: 1.55rem;\n}\n\n.psd-column .form-control {\n\theight: 1.85rem;\n\tfont-size: 0.78rem;\n\ttext-align: right;\n}\n\n@media (max-width: 991.98px) {\n\t.psd-grid-four-column {\n\t\tgrid-template-columns: repeat(2, minmax(0, 1fr));\n\t}\n}\n\n@media (max-width: 575.98px) {\n\t.psd-grid-four-column {\n\t\tgrid-template-columns: 1fr;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
